import createIcon from '../../createIcon';

/**
 * @component @name DocumentScanner
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAzSDRWNkgyVjFIN1YzWk0yMiA2VjFIMTdWM0gyMFY2SDIyWk03IDIxSDRWMThIMlYyM0g3VjIxWk0yMCAxOFYyMUgxN1YyM0gyMlYxOEgyMFpNMTkgMThDMTkgMTkuMSAxOC4xIDIwIDE3IDIwSDdDNS45IDIwIDUgMTkuMSA1IDE4VjZDNSA0LjkgNS45IDQgNyA0SDE3QzE4LjEgNCAxOSA0LjkgMTkgNlYxOFpNMTUgOEg5VjEwSDE1VjhaTTE1IDExSDlWMTNIMTVWMTFaTTE1IDE0SDlWMTZIMTVWMTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DocumentScanner = createIcon('DocumentScanner', [
  [
    'path',
    {
      d: 'M7 3H4V6H2V1H7V3ZM22 6V1H17V3H20V6H22ZM7 21H4V18H2V23H7V21ZM20 18V21H17V23H22V18H20ZM19 18C19 19.1 18.1 20 17 20H7C5.9 20 5 19.1 5 18V6C5 4.9 5.9 4 7 4H17C18.1 4 19 4.9 19 6V18ZM15 8H9V10H15V8ZM15 11H9V13H15V11ZM15 14H9V16H15V14Z',
      key: '1rnytj',
    },
  ],
]);

export default DocumentScanner;
